import { Log } from '@yoummday/ymmd-logger';
import YmmdRouter from '@yoummday/ymmd-router';

const routeFiles: Record<string, YmmdRouter['ymdRoutes']> = import.meta.glob(
	['./**/_routes.ts'],
	{
		eager: true,
		import: 'default',
	},
);

export const Router = new YmmdRouter(import.meta.env.BASE_URL);

Object.values(routeFiles).forEach((routes) => {
	Router.registerRoutes(routes);
});

Router.notFound(() => {
	Router.navigate('/notfound', {
		updateBrowserURL: false,
	});
	const { url } = Router.getCurrentLocation();
	Log.error(new Error(`Not found: ${url}`));
});
